import { useRef, useState } from 'react';
import { useRouterState } from '@tanstack/react-router';
import { useQueryClient } from '@tanstack/react-query';

import { listIntelligenceReports } from '../../api/endpoints/intelligence';
import { AdvisorOrb } from './AdvisorOrb';
import { IntelligenceDrawer } from './IntelligenceDrawer';
import { INTELLIGENCE_REPORTS_KEY } from './queries';
import { useIntelligenceAccess } from './useIntelligenceAccess';

const LAUNCHER_ORB = 24;
const INTELLIGENCE_PATH = '/inteligencia';
const PREFETCH_STALE_MS = 30_000;

const onIntelligenceScreen = (pathname: string) =>
  pathname === INTELLIGENCE_PATH || pathname.startsWith(`${INTELLIGENCE_PATH}/`);

/**
 * Dale Agents from any screen: a button that opens the team's latest report in
 * a drawer. Owners on Max or higher only, and never on the reports themselves.
 */
export function IntelligenceLauncher() {
  const allowed = useIntelligenceAccess();
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  const queryClient = useQueryClient();
  const [open, setOpen] = useState(false);
  const buttonRef = useRef<HTMLButtonElement>(null);

  if (!allowed || onIntelligenceScreen(pathname)) return null;

  const prefetch = () => {
    void queryClient.prefetchQuery({
      queryKey: INTELLIGENCE_REPORTS_KEY,
      queryFn: listIntelligenceReports,
      staleTime: PREFETCH_STALE_MS,
    });
  };
  const close = () => {
    setOpen(false);
    buttonRef.current?.focus();
  };

  return (
    <>
      <button
        ref={buttonRef}
        type="button"
        className="intel-launcher"
        aria-haspopup="dialog"
        aria-expanded={open}
        onPointerEnter={prefetch}
        onFocus={prefetch}
        onClick={() => setOpen(true)}
      >
        <AdvisorOrb personaId="direccion" size={LAUNCHER_ORB} />
        <span className="intel-launcher-label">Dale Agents</span>
      </button>
      <IntelligenceDrawer open={open} onClose={close} />
    </>
  );
}
